import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { IoArrowBackSharp } from 'react-icons/io5';

import theme from '@styles/theme';

import StyledButton from '@components/styled/StyledButton';

type FullFormPageProps = {
    title?: string;
    subTitle?: string;
    buttonTitle: string;
    buttonColor?: string;
    buttonWidth?: number;
    buttonHeight?: number;
    onSubmit: () => void;
    children: React.ReactNode;
    loading?: boolean;
};

const FullFormPage = ({
    title,
    subTitle,
    buttonTitle,
    buttonColor,
    buttonWidth = 80,
    buttonHeight = 32,
    onSubmit,
    loading,
    children
}: FullFormPageProps) => {
    const navigate = useNavigate();
    const handleGoBack = () => {
        if (!window.confirm('페이지 이동 시 입력된 정보가 모두 사라집니다.'))
            return;
        navigate(-1);
    };
    return (
        <>
            <Header>
                <HeaderContainer>
                    <GoBackBtn onClick={handleGoBack}>
                        <IoArrowBackSharp size={24} />
                        <Text>뒤로가기</Text>
                    </GoBackBtn>
                    <StyledButton
                        width={buttonWidth}
                        height={buttonHeight}
                        fontSize={14}
                        bgColor={buttonColor}
                        title={buttonTitle}
                        onClick={onSubmit}
                        loading={loading}
                    />
                </HeaderContainer>
            </Header>
            <Container>
                <TitleArea>
                    <Title>{title}</Title>
                    <SubTitle>{subTitle}</SubTitle>
                </TitleArea>
                <Contents>{children}</Contents>
            </Container>
        </>
    );
};

export default FullFormPage;

const Header = styled.header`
    position: sticky;
    top: 0;
    width: 100%;
    height: 80px;
    border-bottom: ${theme.colors.ultraLightGrayBorder} 1px solid;
    background-color: ${theme.colors.whiteColor};
    z-index: 5;
`;
const Container = styled.div`
    margin: 0 auto;
    width: 1280px;
`;
const HeaderContainer = styled(Container)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: inherit;
`;
const GoBackBtn = styled.button`
    display: flex;
    align-items: center;
`;

const Text = styled.span`
    margin-left: 12px;
    font-size: 14px;
`;
const TitleArea = styled.div`
    padding: 32px 0;
`;
const Title = styled.h2`
    font-size: 24px;
    font-family: PretendardSemiBold, sans-serif;
`;
const SubTitle = styled.h3`
    margin-top: 12px;
    font-size: 14px;
    color: ${theme.colors.deepGrayFontColor};
`;
const Contents = styled.div``;
